import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Briefcase, Clock } from 'lucide-react';
import { Layout } from '@/components/layout';
import { Button } from '@/components/ui/button';
import SEO from '@/components/shared/SEO';

const CareersPage = () => {
  return (
    <Layout>
      <SEO
        title="Careers"
        description="Join the Portico Systems team. Explore career opportunities in commercial flooring solutions."
        canonicalUrl="/careers"
      />
      <section className="min-h-[70vh] flex items-center justify-center bg-muted py-16">
        <div className="container-portico">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-2xl mx-auto text-center"
          >
            {/* Icon */}
            <div className="w-24 h-24 bg-primary-bg rounded-full flex items-center justify-center mx-auto mb-8">
              <Briefcase className="w-12 h-12 text-white" />
            </div>

            {/* Content */}
            <h1 className="font-heading text-4xl md:text-5xl font-bold mb-4">
              Careers at Portico
            </h1>
            <p className="text-xl text-muted-foreground mb-8">
              We're building something great, and we'd love for you to be part of it.
            </p>

            {/* Coming Soon Box */}
            <div className="bg-card rounded-2xl shadow-xl p-8 border border-border mb-8">
              <div className="flex items-center justify-center gap-2 text-secondary mb-4">
                <Clock className="w-6 h-6" />
                <span className="font-semibold text-lg">Coming Soon</span>
              </div>
              <p className="text-muted-foreground mb-6">
                Our careers page is currently under construction. We're working on bringing you 
                exciting opportunities to join the Portico Systems team.
              </p>
              <p className="text-sm text-muted-foreground">
                In the meantime, feel free to reach out to us directly at{' '}
                <a href="mailto:hr@porticosystems.com" className="text-primary hover:underline">
                  hr@porticosystems.com
                </a>
              </p>
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/about">
                <Button variant="outline" size="lg">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Back to About Us
                </Button>
              </Link>
              <Link to="/contact">
                <Button size="lg">
                  Contact Us
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default CareersPage;
